var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.promoCode
      ? _c("div", { staticClass: "d-flex" }, [
          _c("div", [
            _c(
              "span",
              {
                staticClass: "badge p-3 text-secondary",
                staticStyle: { "background-color": "rgba(0, 0, 0, 0.08)" },
              },
              [
                _c("i", { staticClass: "fas fa-tag me-2" }),
                _vm._v(" "),
                _c("span", { staticClass: "text-dark" }, [
                  _vm._v(_vm._s(_vm.promoCode.code)),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "text-secondary ms-2",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.removeCode.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ms-auto" }),
        ])
      : _c("div", [
          _c("div", {}, [
            !_vm.haveCouponCode
              ? _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "text-purple fw-semibold small",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.haveCouponCode = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm._f("translate")("Have a coupon code?")) +
                          "\n        "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.haveCouponCode
              ? _c("div", [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userCode,
                          expression: "userCode",
                        },
                      ],
                      ref: "couponInput",
                      staticClass: "form-control form-control-sm me-2",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("Promo Code"),
                      },
                      domProps: { value: _vm.userCode },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.checkCode.apply(null, arguments)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.userCode = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm",
                        class: {
                          "btn-dark": _vm.userCode,
                          "btn-outline-secondary": !_vm.userCode,
                        },
                        on: { click: _vm.checkCode },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("translate")("Apply")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.message
                    ? _c("div", [
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.message)),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }